import { render, staticRenderFns } from "./MainContentProfile.vue?vue&type=template&id=47cf142d&scoped=true&lang=pug"
import script from "./MainContentProfile.vue?vue&type=script&lang=js"
export * from "./MainContentProfile.vue?vue&type=script&lang=js"
import style0 from "./MainContentProfile.vue?vue&type=style&index=0&id=47cf142d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf142d",
  null
  
)

export default component.exports